// extracted by mini-css-extract-plugin
export var AddMargin = "SkeletonBlocks-module--AddMargin--9407e";
export var Block = "SkeletonBlocks-module--Block--5e643";
export var Image = "SkeletonBlocks-module--Image--9435b";
export var Layout = "SkeletonBlocks-module--Layout--30e8a";
export var NoBlocks = "SkeletonBlocks-module--NoBlocks--7c91f";
export var Wrapper = "SkeletonBlocks-module--Wrapper--0d120";
export var pulse = "SkeletonBlocks-module--pulse--1d808";